module.exports = __webpack_public_path__ + "37892a1ff928c6317bf5eb5cf58102f9.png";